var React = require('react');

function PauseLg (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("title",{"key":1},"Asset 7300ppi"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"pause"},[React.createElement("rect",{"className":"media-control-lg","width":"45.01","height":"192","rx":"22.47","key":0}),React.createElement("rect",{"className":"media-control-lg","x":"83.56","width":"45.01","height":"192","rx":"22.47","key":1})]))]);
}

PauseLg.defaultProps = {"width":"40px","height":"40px","viewBox":"0 0 128.57 192"};

module.exports = PauseLg;

PauseLg.default = PauseLg;
